export const SortingTypes = [
  // "Best Sellers",
  "Price (low to high)",
  "Price (high to low)",
];

export const QUIZ_TYPE = "mascara";
export const HEADER_TEXT = "Mascara Quiz";
export const RECOMMENDED_TEXT = "Here's what we recommend.";
export const START_OVER = "Start Over";
export const SORT_BY = "Sort by:";
export const RESULTS = "Results";
export const FILTER = "Filter";
export const VIEW_DETAILS = "View Details";
export const PRICE_RANGE = "Price Range";
export const RATING = "Rating";
export const GO_BUTTON = "Go";
export const BACK_BUTTON = "Back";
export const SELECT_ALL_THAT_APPLY_TITLE = "Select all that apply";
export const MIN_LABEL = "min";
export const MAX_LABEL = "max";
export const SKIP_NEXT_BUTTON = "Skip/Next";
export const START_QUIZ_BUTTON = "Start Quiz";
export const FIRST_QUESTION = "What kind of lash products are you looking for?";
export const FIRST_QUESTION_ANSWERS = ["Mascara", "False lashes"];
export const HOME_PAGE_TITLE_TEXT =
  "Let us help you find amazing lashes or mascara! Take the quiz by selecting questions to get the right recommendations.";
export const NO_RESULT_FOUND_TEXT =
  "There are no products available that match your criteria. Try adjusting the filters.";
